import { useFlags } from 'launchdarkly-react-client-sdk';
import type { LaunchDarklyFlags } from '../types/launch-darkly';
import { usePartnerProfile } from './usePartnerSettings';

export function useAllFlags() {
  const ld = useFlags<LaunchDarklyFlags>();
  const { partner } = usePartnerProfile();

  return {
    ld,
    partnerFlags: partner?.featureCustomizations,
  };
}
